import { DeployConfig, EnvironmentConfig } from "../../configuration/interface"
import { createEnvironmentRegExp } from "../../util/tagsHelpers"

// CI_COMMIT_REF_NAME
export const getCurrentEnvironment = (deployConfig: DeployConfig): string => {

  const environmentConfig = getCurrentEnvironmentConfig(deployConfig)
  const { environmentName } = environmentConfig
  return environmentName


}

export const getCurrentEnvironmentConfig = (deployConfig: DeployConfig): EnvironmentConfig => {
  if (!process.env.CI_COMMIT_TAG) {
    throw new Error(`process.env.CI_COMMIT_TAG is not defined or falsy. This package only allows deploys triggered by tags.`)
  }
  const environmentConfig = deployConfig.environments.find(environmentConfig => {
    const { environmentTagIsSemver, environmentTagIsVersioned, environmentName, isMultiEnv } = environmentConfig
    // RegExp part for any string for multiEnv instead of branch which is unknownNow
    const branch = isMultiEnv ? '.*?' : undefined
    const environmentTagRegExp = createEnvironmentRegExp(environmentTagIsSemver, environmentTagIsVersioned, environmentName, branch)
    return process.env.CI_COMMIT_TAG.match(environmentTagRegExp) !== null
  })

  if (!environmentConfig) {
    throw new Error(`Unknown environment`)
  }

  return environmentConfig

}
